import axios from "./axyos";

export type RateAdDto = {
  id: string;
  bookingId?: string;
  adId?: string;
  userId?: string;
  authorName?: string;
  rating: number;
  content: string;
  valide?: boolean;
  adTitle?: string;
  createdAt?: string;
  updatedAt?: string;
  validatedAt?: string | null;
  ad?: {
    id: string;
    title?: string;
    title_i18n?: Record<string, string>;
    owner?: {
      id: string;
      firstName?: string;
      lastName?: string;
      email?: string;
      phone?: string;
      indicatif?: string;
    } | null;
  } | null;
  user?: {
    id: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    phone?: string;
    indicatif?: string;
  } | null;
};

export type StayReviewRequestDto = {
  bookingId: string;
  adId: string;
  adTitle: string;
  clientName: string;
};

export const loadStayReviewRequestApi = (token: string) =>
  axios.get<{ data?: StayReviewRequestDto; status?: number }>(`/rate-ads/review-request/${encodeURIComponent(token)}`);

export const submitStayReviewApi = (token: string, payload: { rating: number; comment: string }) =>
  axios.post<{ data?: RateAdDto; status?: number }>(`/rate-ads/review-request/${encodeURIComponent(token)}`, payload);

export const listApprovedRateAdsByAdApi = (adId: string) =>
  axios.get<{ data?: RateAdDto[]; count?: number; status?: number }>(`/ads/${encodeURIComponent(adId)}/rate-ads`);

export const listRateAdsForModerationApi = (params: {
  valide?: boolean | "";
  q?: string;
  dateFrom?: string;
  dateTo?: string;
  limit?: number;
  cursor?: string | null;
}) =>
  axios.get<{ data?: RateAdDto[]; count?: number; hasMore?: boolean; nextCursor?: string | null; status?: number }>("/rate-ads/moderation", {
    params: {
      ...params,
      cursor: params.cursor || undefined,
      valide: typeof params.valide === "boolean" ? String(params.valide) : undefined,
    },
  });

export const validateRateAdByIdApi = (reviewId: string, valide = true) =>
  axios.post<{ data?: RateAdDto; status?: number }>(`/rate-ads/${encodeURIComponent(reviewId)}/validate`, { valide });
